import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinrahudaundpune() {



const cardData =
  {
    keyword: 'Bus Hire in Rahu Daund Pune',
    heading: 'Sanavi Travels: Bus Hire in Rahu Daund Pune',
    headingDescription: 'Sanavi Travels offers reliable and professionally managed Bus Hire in Rahu Daund Pune, providing safe, comfortable, and well-organized transportation solutions for families, villagers, corporate teams, schools, wedding guests, picnic groups, and outstation travelers. Rahu, located in Daund taluka of Pune district, is surrounded by agricultural areas, educational institutions, growing residential pockets, and frequently hosts social and religious gatherings that require dependable group travel arrangements. To meet these diverse requirements, we provide a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for short local trips as well as long-distance journeys. Each bus is maintained with comfortable seating, proper ventilation, smooth suspension, and sufficient luggage space to ensure a relaxed travel experience for passengers of all age groups.',

    top: 'Top Places to Visit Near Rahu Daund Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Rahu Village",
    "description": "Rahu is a well-known village in Daund taluka, Pune district, recognized for its strong community life, agricultural background, and regular social gatherings. The village frequently hosts weddings, religious ceremonies, and cultural events that require organized group transportation. Hiring a bus for travel within and from Rahu ensures that large groups move together comfortably, arrive on time, and avoid coordination challenges. Bus rentals play an essential role in managing village-level travel needs efficiently and economically."
  },
  {
    "title": "Daund Town",
    "description": "Daund is a major railway junction and commercial center located close to Rahu, attracting daily travelers for business, education, healthcare, and official work. Residents of Rahu often travel to Daund for markets, offices, and social purposes. Bus hire services provide a convenient and cost-effective solution for group travel between Rahu and Daund, especially during busy hours and festive seasons."
  },
  {
    "title": "Agricultural Belt Around Rahu",
    "description": "The region surrounding Rahu is dominated by fertile agricultural land producing sugarcane, grains, and seasonal crops. These areas witness frequent travel for farming activities, family visits, and community events. Bus rentals offer a reliable means of transporting groups safely across rural roads while maintaining comfort and schedule discipline."
  },
  {
    "title": "Local Temples and Religious Sites",
    "description": "Several temples and spiritual centers near Rahu attract devotees throughout the year, particularly during festivals and special religious occasions. Group travel by bus makes temple visits more organized, economical, and convenient, allowing families and devotees to travel together without logistical concerns."
  },
  {
    "title": "Weekly Markets and Rural Bazaars",
    "description": "Weekly markets around Rahu serve as important hubs for trade and social interaction, drawing visitors from nearby villages. Bus hire services are commonly used by trader groups and community members for collective travel to these markets, ensuring ease and affordability."
  },
  {
    "title": "Wedding Lawns and Event Halls",
    "description": "Marriage halls, open lawns, and event venues in and around Rahu and Daund depend heavily on bus rentals for guest transportation. Buses help manage large crowds, reduce parking congestion, and ensure guests reach venues comfortably and on time."
  },
  {
    "title": "Educational Institutions Nearby",
    "description": "Schools and colleges in the surrounding region organize excursions, sports meets, and educational tours regularly. Bus hire services ensure safe, supervised, and punctual transportation for students and staff, making group travel smooth and secure."
  },
  {
    "title": "Picnic and Leisure Locations",
    "description": "Open countryside areas and leisure spots near Rahu are popular for school picnics, family outings, and office get-togethers. Hiring a bus allows groups to enjoy the journey together and return safely without the stress of managing multiple vehicles."
  },
  {
    "title": "Industrial and Commercial Areas",
    "description": "Small industrial units and commercial establishments around Daund create regular demand for employee and visitor transport from Rahu. Bus hire services support organized corporate travel and staff transportation needs efficiently."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Rahu is well connected to Pune, Solapur, Ahmednagar, Shirdi, and other nearby destinations. Bus rentals are ideal for outstation group travel, offering comfort, safety, and cost-effective transportation for tours, pilgrimages, and family trips."
  }
]
,



"services": [
{
"name": "Bus Hire in Rahu Daund Pune",
"description": "Bus Hire in Rahu Daund Pune provides dependable and comfortable buses for families, schools, corporate teams, and social gatherings. This service is ideal for weddings, picnics, school trips, religious journeys, and outstation travel. Our buses are spacious, clean, and well-maintained, featuring comfortable seating, proper ventilation, smooth suspension, and ample luggage space. Professional drivers ensure disciplined driving, punctual pickups, and safe journeys, making group travel organized and stress-free."
},
{
"name": "Bus on Rent Rahu Daund",
"description": "Bus on Rent Rahu Daund offers flexible rental options for both short-distance and long-distance travel. Whether it is a village function, family event, or extended tour, this service ensures reliable transportation with suitable bus options for different group sizes."
},
{
"name": "AC Bus Rental Rahu Daund",
"description": "AC Bus Rental Rahu Daund is perfect for travelers seeking enhanced comfort during hot weather and long journeys. Fully air-conditioned interiors, cushioned seating, and reduced travel fatigue make AC buses ideal for weddings, corporate travel, and extended tours."
},
{
"name": "Non AC Bus Hire Rahu",
"description": "Non AC Bus Hire Rahu provides economical and reliable transportation for short-distance routes, rural travel, school trips, and budget-friendly group journeys without compromising safety."
},
{
"name": "Luxury Bus Hire Rahu Daund",
"description": "Luxury Bus Hire Rahu Daund delivers premium travel experiences with modern interiors, stylish seating, and superior comfort. Ideal for weddings, VIP guests, and special events, luxury buses ensure an elegant and memorable journey."
},
{
"name": "Mini Bus Hire Rahu",
"description": "Mini Bus Hire Rahu is suitable for small to medium-sized groups such as family outings, office teams, and local events, offering comfort, flexibility, and economical pricing."
},
{
"name": "32 Seater Bus Hire Rahu",
"description": "32 Seater Bus Hire Rahu is ideal for medium-sized groups including school excursions, corporate outings, and community programs, providing balanced capacity and comfort."
},
{
"name": "35 Seater Bus Rental Rahu Daund",
"description": "35 Seater Bus Rental Rahu Daund supports large-group travel needs such as weddings, religious tours, and long-distance journeys with organized seating and professional drivers."
},
{
"name": "Bus Hire Rahu for Wedding",
"description": "Bus Hire Rahu for Wedding ensures timely and coordinated transportation for wedding guests and family members, simplifying event logistics and reducing travel stress."
},
{
"name": "Bus Hire Rahu for Corporate Travel",
"description": "Bus Hire Rahu for Corporate Travel supports employee movement, meetings, conferences, and team outings with a strong focus on punctuality and professionalism."
},
{
"name": "Bus Hire Rahu for Picnic",
"description": "Bus Hire Rahu for Picnic provides safe and enjoyable transportation for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Rahu Daund Outstation",
"description": "Bus Rental Rahu Daund Outstation offers dependable long-distance transportation to nearby cities and pilgrimage destinations with passenger comfort as a priority."
},
{
"name": "Bus Hire Rahu with Driver",
"description": "Bus Hire Rahu with Driver provides chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to relax."
},
{
"name": "Cheap Bus Hire Rahu Daund",
"description": "Cheap Bus Hire Rahu Daund delivers budget-friendly bus hire solutions without compromising on cleanliness, safety, or service reliability."
},
{
"name": "Best Bus Service Rahu Daund",
"description": "Best Bus Service Rahu Daund is recognized for clean buses, disciplined drivers, transparent pricing, and customer-focused service, making Sanavi Travels a trusted choice."
}
],
"tableData": [
["Bus Hire in Rahu Daund Pune", "Bus on Rent Rahu Daund"],
["AC Bus Rental Rahu", "Non AC Bus Hire Rahu"],
["Luxury Bus Rahu Daund", "Mini Bus Hire Rahu"],
["32 Seater Bus Rahu", "35 Seater Bus Rahu Daund"],
["Wedding Bus Rahu", "Corporate Bus Rahu"],
["Picnic Bus Rahu", "Outstation Bus Rahu"],
["Bus Hire Rahu with Driver", "Cheap Bus Hire Rahu"],
["Best Bus Service Rahu", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Rahu Daund Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus hire services in Rahu Daund Pune for families, schools, and corporate groups."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "Our buses are regularly maintained to ensure comfort, cleanliness, and a smooth travel experience."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Rahu, Daund, Pune, and nearby routes, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "We follow honest pricing policies with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose hourly, full-day, multi-day, or customized rental plans as per travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure on-time pickups and disciplined operations for stress-free group travel."
  }
]

}

const faqData = [
  {
    question: 'Do you provide bus hire services in Rahu Daund Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Rahu Daund Pune for all types of group travel.'
  },
  {
    question: 'What types of buses are available in Rahu?',
    answer: 'We provide AC buses, Non AC buses, mini buses, luxury buses, and 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus hire available for weddings and picnics?',
    answer: 'Yes, we provide dedicated bus services for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Rahu?',
    answer: 'Yes, outstation bus rentals are available from Rahu to multiple destinations.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are cleaned and sanitized before each trip.'
  },
  {
    question: 'Is customer support available during travel?',
    answer: 'Yes, our 24/7 customer support team remains available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Jagtap',
    feedback: 'We hired a bus from Rahu for a wedding near Daund. The service was smooth and very comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Shinde',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Rahu. Clean bus and disciplined driver.',
    rating: 5
  }
];















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Rahu Daund Pune - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Rahu Daund Pune for weddings, corporate travel, picnics, and outstation trips. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Rahu Daund Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Rahu Daund Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/221.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinrahudaundpune;